import { render, staticRenderFns } from "./PixelClicks.vue?vue&type=template&id=3ff585a9&"
import script from "./PixelClicks.vue?vue&type=script&lang=js&"
export * from "./PixelClicks.vue?vue&type=script&lang=js&"
import style0 from "./PixelClicks.vue?vue&type=style&index=0&id=3ff585a9&prod&lang=scss&"
import style1 from "./PixelClicks.vue?vue&type=style&index=1&id=3ff585a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports